import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/blog/blog-4.jpg'
import _imports_1 from '../../assets/images/blog/blog-5.jpg'
import _imports_2 from '../../assets/images/blog/blog-3.jpg'


const _hoisted_1 = { class: "blog-wrap pt-100 pb-75 bg-alco" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "section-title style1 text-center mb-40" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Latest Insights From Ruxa"),
  /*#__PURE__*/_createElementVNode("h2", { class: "text-white" }, "Our Latest Articles")
], -1)
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-xl-4 col-lg-6 col-md-6" }
const _hoisted_6 = { class: "blog-card style2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "blog-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Image"
  })
], -1)
const _hoisted_8 = { class: "blog-info" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<ul class=\"blog-metainfo list-style\"><li><i class=\"flaticon-user\"></i> <a href=\"#\">Admin</a></li><li><i class=\"flaticon-calendar\"></i>12 Dec, 2021</li><li><i class=\"flaticon-chat-comment-oval-speech-bubble-with-text-lines\"></i>2 Comment</li></ul>", 1)
const _hoisted_10 = { class: "col-xl-4 col-lg-6 col-md-6" }
const _hoisted_11 = { class: "blog-card style2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "blog-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Image"
  })
], -1)
const _hoisted_13 = { class: "blog-info" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<ul class=\"blog-metainfo list-style\"><li><i class=\"flaticon-user\"></i> <a href=\"#\">Admin</a></li><li><i class=\"flaticon-calendar\"></i>12 Dec, 2021</li><li><i class=\"flaticon-chat-comment-oval-speech-bubble-with-text-lines\"></i>2 Comment</li></ul>", 1)
const _hoisted_15 = { class: "col-xl-4 col-lg-6 col-md-6" }
const _hoisted_16 = { class: "blog-card style2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "blog-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Image"
  })
], -1)
const _hoisted_18 = { class: "blog-info" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<ul class=\"blog-metainfo list-style\"><li><i class=\"flaticon-user\"></i> <a href=\"#\">Admin</a></li><li><i class=\"flaticon-calendar\"></i>12 Dec, 2021</li><li><i class=\"flaticon-chat-comment-oval-speech-bubble-with-text-lines\"></i>1 Comment</li></ul>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("h3", null, [
                _createVNode(_component_router_link, { to: "/blog-details-right-sidebar" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Why You Should Open Bank Account To Pay Online")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("h3", null, [
                _createVNode(_component_router_link, { to: "/blog-details-right-sidebar" }, {
                  default: _withCtx(() => [
                    _createTextVNode("The Benefits That We Get Through Credit Cards")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("h3", null, [
                _createVNode(_component_router_link, { to: "/blog-details-right-sidebar" }, {
                  default: _withCtx(() => [
                    _createTextVNode("You Can Trust Me And Business With Together")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}